import { render, staticRenderFns } from "./FarmingProcessList.vue?vue&type=template&id=72fa48fb&"
import script from "./FarmingProcessList.vue?vue&type=script&lang=js&"
export * from "./FarmingProcessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports